import { render, staticRenderFns } from "./OpenIncidents.vue?vue&type=template&id=652fbcea&scoped=true"
import script from "./OpenIncidents.vue?vue&type=script&lang=js"
export * from "./OpenIncidents.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "652fbcea",
  null
  
)

export default component.exports